import React, { useEffect, useMemo, useRef } from "react";
import { ReferenceInput, SelectInput } from "ra-ui-materialui";
import { useForm, useFormState } from "react-final-form";

import { get } from "lodash";
import { useTranslate } from "react-admin";

const optionText = (option) =>
  option?.code ? `${option.code} - ${option.description}` : option?.description;
const ResearchAreaInput = ({
  level,
  dependency = undefined,
  tab = 1,
  ...props
}) => {
  const translate = useTranslate();
  const formState = useFormState();
  const didMount = useRef(false);
  const parentId = get(formState.values, dependency);

  const form = useForm();
  const researchAreaIdRoot = useMemo(
    () => get(formState.values, props.source),
    [props.source, formState.values]
  );
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }
    if (props.source === "research_area_id_root") {
      form.change("research_area_id", null);
    }
  }, [props.source, form, researchAreaIdRoot]);

  return (
    <ReferenceInput
      {...props}
      reference="research-areas"
      filter={{ level, parent_id: parentId }}
      perPage={100}
      sort={{ field: "id", order: "ASC" }}
    >
      <SelectInput
        optionText={optionText}
        helperText={translate(
          `resources.research-projects.fields.${props.source}.help`
        )}
      />
    </ReferenceInput>
  );
};
export default ResearchAreaInput;
